import { Refinement } from "react-instantsearch-core";
import { filter, includes } from "lodash-es";

export const filterFacets = (
  facet?: Refinement,
  ignore?: { [p: string]: string[] },
  selectedCatSlug?: string[]
): Refinement | undefined => {
  if (!facet) {
    return;
  }

  if (!ignore) {
    return facet;
  }

  const ignoreFacets = ignore[facet.attribute];
  if (!ignoreFacets) {
    return facet;
  }

  const categories = selectedCatSlug?.map((c) => {
    const splitted = c.split("||");
    return splitted.slice(0, 6).join("||");
  });

  if (includes(categories, ignoreFacets[0])) {
    return facet;
  }

  if (
    facet.currentRefinement.length === 1 &&
    includes(ignoreFacets, facet.currentRefinement[0])
  ) {
    return;
  }

  facet.currentRefinement = filter(
    facet.currentRefinement,
    (e) => !includes(ignoreFacets, e)
  );
  facet.items = filter(facet.items, (e) => !includes(ignoreFacets, e.label));

  return facet;
};
